import { prettyPrice } from '@aviata/text-fns';
import type { DirectiveBinding } from 'vue';

import { appLocale } from '../../..';

function setElementPrice(
  el: HTMLElement,
  bindings: DirectiveBinding<number | string>,
) {
  if (Number(bindings.value) > 0) {
    el.textContent = `${prettyPrice(String(bindings.value))} ₸`;
  } else {
    const isKKLocale =
      appLocale.lib.getAppLocale() === appLocale.config.locales.KK;
    const isENLocale =
      appLocale.lib.getAppLocale() === appLocale.config.locales.EN;

    if (isKKLocale) {
      el.textContent = 'Тегін';
    } else if (isENLocale) {
      el.textContent = 'Free';
    } else {
      el.textContent = 'Бесплатно';
    }
  }
}

export const vPrice = {
  mounted(el: HTMLElement, bindings: DirectiveBinding<number | string>) {
    setElementPrice(el, bindings);
  },
  updated(el: HTMLElement, bindings: DirectiveBinding<number | string>) {
    setElementPrice(el, bindings);
  },
};
